import React from "react";
import PropTypes from "prop-types";
import Image from "../components/image_new";

const ContactCards = ({ componentDetails }) => {
  let hasImages = false;
  const cards = componentDetails.fields.modular_content.map((contact) => {
    if (!hasImages) {
      hasImages = contact.kenticoElements.image__image_file.value.length > 0;
    }
    return (
      <div
        className={`cards__item ${
          contact.kenticoElements.image__image_file.value.length ? "has-image" : "no-image"
        }`}
        key={contact.system.codename}
      >
        <div to="" className="cards__link">
          <div className="cards__image">
            {contact.kenticoElements.image__image_file.value.length ? (
              <Image image={contact.kenticoElements.image__image_file.value[0]} crop="16_9" />
            ) : (
              ""
            )}
          </div>
          <div className="cards__text">
            <div className="cards__top">
              {contact.kenticoElements.title.value ? (
                <p className="cards__meta">{contact.kenticoElements.title.value}</p>
              ) : (
                ""
              )}
              {contact.kenticoElements.label.value ? (
                <p className="cards__meta">{contact.kenticoElements.label.value}</p>
              ) : (
                ""
              )}
              {contact.kenticoElements.region.value ? (
                <p className="cards__meta">{contact.kenticoElements.region.value}</p>
              ) : (
                ""
              )}
            </div>
            <p className="cards__title">{contact.kenticoElements.full_name.value}</p>
            <div className="cards__bottom">
              {contact.kenticoElements.phone_number.value ? (
                <p className="cards__phone">
                  Telefon: {contact.kenticoElements.phone_number.value.toString().substring(0, 4)}{" "}
                  {contact.kenticoElements.phone_number.value.toString().substring(4, 8)}
                </p>
              ) : (
                ""
              )}
              <div class="cards__cta">
                <a
                  href={`tel:${contact.kenticoElements.phone_number.value}`}
                  className="cards__read-more"
                >
                  Ring op
                </a>
                <a
                  href={`mailto:${contact.kenticoElements.email.value.toLowerCase()}`}
                  className="cards__read-more"
                >
                  Send email
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  });

  return (
    <section className="c-component c-consultants">
      <div className={`cards cards--stacked ${hasImages ? "has-images" : "no-images"}`}>
        {cards}
      </div>
    </section>
  );
};

ContactCards.propTypes = {
  componentDetails: PropTypes.object,
};

export default ContactCards;
